/**
 * Returns a given css class if the current location is part of the desired routes
 * @param activeRoutes
 * @param location 
 * @param className 
 * @returns
 */
export const getActiveRouteClass = (activeRoutes: string[], location: string, className: string) => activeRoutes.includes(location) ? className : ''